<div class="reports-page">
  <div class="header">
    <h2>Reports</h2>
    <div class="actions">
      <button mat-flat-button color="primary" (click)="runReport()">Run Report</button>
      <button mat-stroked-button color="accent" (click)="printReport()">Print</button>
      <button mat-stroked-button (click)="resetFilters()">Reset</button>
    </div>
  </div>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Report Type</mat-label>
      <mat-select [(value)]="reportType">
        <mat-option value="deliveries">Deliveries</mat-option>
        <mat-option value="maintenance">Maintenance</mat-option>
        <mat-option value="supply">Supply</mat-option>
        <mat-option value="staff">Staff</mat-option>
        <mat-option value="projects">Projects</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>From</mat-label>
      <input matInput type="date" [(ngModel)]="filters.from" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>To</mat-label>
      <input matInput type="date" [(ngModel)]="filters.to" />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'deliveries'">
      <mat-label>Payment Status</mat-label>
      <mat-select [(value)]="filters.isPaid">
        <mat-option value="all">All</mat-option>
        <mat-option value="paid">Paid</mat-option>
        <mat-option value="unpaid">Unpaid</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'deliveries'">
      <mat-label>Rider</mat-label>
      <mat-select [(value)]="filters.riderName">
        <mat-option value="">All Riders</mat-option>
        <mat-option *ngFor="let rider of riders" [value]="rider.fullName">
          {{ rider.fullName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'deliveries'">
      <mat-label>Vehicle</mat-label>
      <mat-select [(value)]="filters.vehicleNumber">
        <mat-option value="">All Vehicles</mat-option>
        <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle.plateNumber">
          {{ vehicle.plateNumber }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'maintenance'">
      <mat-label>Vehicle</mat-label>
      <mat-select [(value)]="filters.vehicleId">
        <mat-option value="">All Vehicles</mat-option>
        <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
          {{ vehicle.plateNumber }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'supply'">
      <mat-label>Product Type</mat-label>
      <mat-select [(value)]="filters.productTypeId" (selectionChange)="onSupplyTypeChange()">
        <mat-option value="">All Types</mat-option>
        <mat-option *ngFor="let t of productTypes" [value]="t.id">{{ t.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'supply'">
      <mat-label>Item Type</mat-label>
      <mat-select [(value)]="filters.productItemId">
        <mat-option value="">All Items</mat-option>
        <mat-option *ngFor="let i of productItems" [value]="i.id">{{ i.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'staff'">
      <mat-label>Staff</mat-label>
      <mat-select [(value)]="filters.staffId">
        <mat-option value="">All Staff</mat-option>
        <mat-option *ngFor="let s of staffList" [value]="s.staffId">{{ s.staffName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'staff'">
      <mat-label>Request Status</mat-label>
      <mat-select [(value)]="filters.requestStatus">
        <mat-option value="all">All</mat-option>
        <mat-option value="Pending">Pending</mat-option>
        <mat-option value="Approved">Approved</mat-option>
        <mat-option value="Rejected">Rejected</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'staff'">
      <mat-label>Request Type</mat-label>
      <mat-select [(value)]="filters.requestType">
        <mat-option value="all">All</mat-option>
        <mat-option value="Leave">Leave</mat-option>
        <mat-option value="Funds">Funds</mat-option>
        <mat-option value="Loan">Loan</mat-option>
        <mat-option value="Other">Other</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'projects'">
      <mat-label>Project</mat-label>
      <mat-select [(value)]="filters.projectId">
        <mat-option value="">All Projects</mat-option>
        <mat-option *ngFor="let p of projectList" [value]="p.id">{{ p.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'projects'">
      <mat-label>Assigned Staff</mat-label>
      <mat-select [(value)]="filters.staffId">
        <mat-option value="">All Staff</mat-option>
        <mat-option *ngFor="let s of staffList" [value]="s.staffId">{{ s.staffName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="reportType === 'projects'">
      <mat-label>Task Status</mat-label>
      <mat-select [(value)]="filters.taskStatus">
        <mat-option value="all">All</mat-option>
        <mat-option value="Pending">Pending</mat-option>
        <mat-option value="In Progress">In Progress</mat-option>
        <mat-option value="Blocked">Blocked</mat-option>
        <mat-option value="Done">Done</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="filters.search" placeholder="Search records..." />
    </mat-form-field>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="report-print-area" *ngIf="rows.length">
    <div class="report-head">
      <h3>{{ title }}</h3>
      <div class="meta">
        <span>Generated: {{ generatedAt | date:'medium' }}</span>
        <span>Rows: {{ rows.length }}</span>
      </div>
      <div class="totals" *ngIf="reportType === 'deliveries'">
        Total Amount: ₦{{ totalAmount | number }}
      </div>
      <div class="totals" *ngIf="reportType === 'maintenance'">
        Total Cost: ₦{{ totalCost | number }}
      </div>
      <div class="totals" *ngIf="reportType === 'supply'">
        Gross: ₦{{ totalSupplyGross | number }} | Net: ₦{{ totalSupplyNet | number }}
      </div>
      <div class="totals" *ngIf="reportType === 'staff'">
        Staff Requests: {{ totalStaffRequests }}
      </div>
      <div class="totals" *ngIf="reportType === 'projects'">
        Tasks: {{ completedProjectTasks }}/{{ totalProjectTasks }} completed
      </div>
      <div class="meta" *ngIf="reportType === 'supply' && supplyAnalytics">
        <span>Dispatches: {{ supplyAnalytics.totalDispatches }}</span>
        <span>Units: {{ supplyAnalytics.totalUnits | number:'1.0-2' }}</span>
        <span>Commission: ₦{{ supplyAnalytics.totalCommission | number:'1.0-0' }}</span>
      </div>
    </div>

    <table mat-table [dataSource]="rows" class="full-table mat-elevation-z1">
      <ng-container matColumnDef="orderDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let r">{{ r.orderDate | date:'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let r">{{ r.customerName }}</td>
      </ng-container>

      <ng-container matColumnDef="contactNumber">
        <th mat-header-cell *matHeaderCellDef>Contact</th>
        <td mat-cell *matCellDef="let r">{{ r.contactNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="deliveryLocation">
        <th mat-header-cell *matHeaderCellDef>Delivery Location</th>
        <td mat-cell *matCellDef="let r">{{ r.deliveryLocation }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let r">₦{{ r.amount | number }}</td>
      </ng-container>

      <ng-container matColumnDef="isPaid">
        <th mat-header-cell *matHeaderCellDef>Paid</th>
        <td mat-cell *matCellDef="let r">{{ r.isPaid ? 'Yes' : 'No' }}</td>
      </ng-container>

      <ng-container matColumnDef="isCancelled">
        <th mat-header-cell *matHeaderCellDef>Cancelled</th>
        <td mat-cell *matCellDef="let r">{{ r.isCancelled ? 'Yes' : 'No' }}</td>
      </ng-container>

      <ng-container matColumnDef="serviceDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let r">{{ r.serviceDate | date:'shortDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="vehiclePlate">
        <th mat-header-cell *matHeaderCellDef>Vehicle</th>
        <td mat-cell *matCellDef="let r">{{ r.vehiclePlate }}</td>
      </ng-container>

      <ng-container matColumnDef="recordType">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let r">{{ r.recordType }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let r">{{ r.description }}</td>
      </ng-container>

      <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>Cost</th>
        <td mat-cell *matCellDef="let r">₦{{ r.cost | number }}</td>
      </ng-container>

      <ng-container matColumnDef="dispatchDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let r">{{ r.dispatchDate | date:'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="productTypeName">
        <th mat-header-cell *matHeaderCellDef>Product Type</th>
        <td mat-cell *matCellDef="let r">{{ r.productTypeName }}</td>
      </ng-container>

      <ng-container matColumnDef="productItemName">
        <th mat-header-cell *matHeaderCellDef>Item Type</th>
        <td mat-cell *matCellDef="let r">{{ r.productItemName }}</td>
      </ng-container>

      <ng-container matColumnDef="buyerName">
        <th mat-header-cell *matHeaderCellDef>Buyer</th>
        <td mat-cell *matCellDef="let r">{{ r.buyerName }}</td>
      </ng-container>

      <ng-container matColumnDef="origin">
        <th mat-header-cell *matHeaderCellDef>From</th>
        <td mat-cell *matCellDef="let r">{{ r.origin || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef>To</th>
        <td mat-cell *matCellDef="let r">{{ r.destination || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="unitCount">
        <th mat-header-cell *matHeaderCellDef>Units</th>
        <td mat-cell *matCellDef="let r">{{ r.unitCount | number:'1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="unitPrice">
        <th mat-header-cell *matHeaderCellDef>Unit Price</th>
        <td mat-cell *matCellDef="let r">₦{{ r.unitPrice | number:'1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="commissionAmount">
        <th mat-header-cell *matHeaderCellDef>Commission</th>
        <td mat-cell *matCellDef="let r">₦{{ r.commissionAmount | number:'1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="totalAmount">
        <th mat-header-cell *matHeaderCellDef>Gross</th>
        <td mat-cell *matCellDef="let r">₦{{ r.totalAmount | number:'1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="netAmount">
        <th mat-header-cell *matHeaderCellDef>Net</th>
        <td mat-cell *matCellDef="let r">₦{{ (r.totalAmount - r.commissionAmount) | number:'1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="staffName">
        <th mat-header-cell *matHeaderCellDef>Staff</th>
        <td mat-cell *matCellDef="let r">{{ r.staffName }}</td>
      </ng-container>

      <ng-container matColumnDef="department">
        <th mat-header-cell *matHeaderCellDef>Department</th>
        <td mat-cell *matCellDef="let r">{{ r.department || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef>Position</th>
        <td mat-cell *matCellDef="let r">{{ r.position || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let r">{{ r.isActive ? 'Active' : 'Inactive' }}</td>
      </ng-container>

      <ng-container matColumnDef="requestType">
        <th mat-header-cell *matHeaderCellDef>Request Type</th>
        <td mat-cell *matCellDef="let r">{{ r.requestType }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Request Status</th>
        <td mat-cell *matCellDef="let r">{{ r.status }}</td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let r">{{ r.title }}</td>
      </ng-container>

      <ng-container matColumnDef="directedToStaffName">
        <th mat-header-cell *matHeaderCellDef>Directed To</th>
        <td mat-cell *matCellDef="let r">{{ r.directedToStaffName || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="requestedAt">
        <th mat-header-cell *matHeaderCellDef>Requested At</th>
        <td mat-cell *matCellDef="let r">{{ r.requestedAt ? (r.requestedAt | date:'short') : '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="projectName">
        <th mat-header-cell *matHeaderCellDef>Project</th>
        <td mat-cell *matCellDef="let r">{{ r.projectName }}</td>
      </ng-container>

      <ng-container matColumnDef="clientName">
        <th mat-header-cell *matHeaderCellDef>Client</th>
        <td mat-cell *matCellDef="let r">{{ r.clientName || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="leadStaffName">
        <th mat-header-cell *matHeaderCellDef>Lead</th>
        <td mat-cell *matCellDef="let r">{{ r.leadStaffName || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="projectStatus">
        <th mat-header-cell *matHeaderCellDef>Project Status</th>
        <td mat-cell *matCellDef="let r">{{ r.projectStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="taskTitle">
        <th mat-header-cell *matHeaderCellDef>Task</th>
        <td mat-cell *matCellDef="let r">{{ r.taskTitle }}</td>
      </ng-container>

      <ng-container matColumnDef="taskStatus">
        <th mat-header-cell *matHeaderCellDef>Task Status</th>
        <td mat-cell *matCellDef="let r">{{ r.taskStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="taskPriority">
        <th mat-header-cell *matHeaderCellDef>Priority</th>
        <td mat-cell *matCellDef="let r">{{ r.taskPriority }}</td>
      </ng-container>

      <ng-container matColumnDef="assignedStaffName">
        <th mat-header-cell *matHeaderCellDef>Assigned To</th>
        <td mat-cell *matCellDef="let r">{{ r.assignedStaffName || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="taskProgressPercent">
        <th mat-header-cell *matHeaderCellDef>Progress</th>
        <td mat-cell *matCellDef="let r">{{ r.taskProgressPercent | number:'1.0-0' }}%</td>
      </ng-container>

      <ng-container matColumnDef="taskDueDate">
        <th mat-header-cell *matHeaderCellDef>Due Date</th>
        <td mat-cell *matCellDef="let r">{{ r.taskDueDate ? (r.taskDueDate | date:'mediumDate') : '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="taskUpdatedAt">
        <th mat-header-cell *matHeaderCellDef>Updated</th>
        <td mat-cell *matCellDef="let r">{{ r.taskUpdatedAt | date:'short' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="currentColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: currentColumns;"></tr>
    </table>
  </div>

  <div class="empty" *ngIf="!loading && !rows.length">
    Run a report to view results.
  </div>
</div>
